import MetaMask from "./assets/MetaMask.png";
import WalletConnect from "./assets/WalletConnect.png";
import TrustWallet from "./assets/TrustWallet.png";

export const providers = [
  {
    name: "MetaMask",
    desc: "",
    logo: MetaMask,
  },
  {
    name: "Wallet Connect",
    desc: "",
    logo: WalletConnect,
  },
  {
    name: "Trust Wallet",
    desc: "",
    logo: TrustWallet,
  },
];
